import React from 'react';
import Nav from './Nav';
import { Outlet } from 'react-router-dom';
import ErrorBoundary from '../../Components/Containers/ErrorBoundary/ErrorBoundary';
import DialoguesWrapper from '../../Components/Dialogues';
import HelpWrapper from '../../Components/Help';
import Mobile from '../../Components/Mobile';
import Assistant, { DesktopPanel } from '../../Components/Assistant';
import Analytics from '../../Components/Analytics';
import { useOffline } from '../../Components/Offline';
import Status from '../../Components/Offline/Status';
import { useSession } from '../../Components/Session';
import NavRedesign from './NavRedesign';
import VoIPWrapper from '../../Components/Voip';

const DesktopLayout = () => {
    const {status} = useOffline();
    const {showRedesign} = useSession();

    return <div className="flex flex-row bg-blue-50 dark:bg-gray-900 justify-center px-2 gap-4">
        <ErrorBoundary fullPage={true}>
            <DialoguesWrapper>
                <HelpWrapper>
                    <Mobile>
                        <VoIPWrapper>
                            <Assistant>
                                {showRedesign ? <NavRedesign /> : <Nav />}

                                <div className="shrink page-container min-h-screen pt-[0.5rem] pr-[0.5rem] flex flex-col">

                                    <Status className="text-center py-1 text-xs rounded-xl mb-2" />

                                    <div className="w-full h-full rounded-xl overflow-hidden surface-1 shadow-lg dark:shadow-none relative"
                                        style={{height: `calc(100% - ${status ? '3rem' : '1rem'})`}}
                                    >

                                        <ErrorBoundary>
                                            <Outlet />
                                        </ErrorBoundary>
                                    </div>
                                </div>

                                <DesktopPanel />
                            </Assistant>
                        </VoIPWrapper>
                    </Mobile>
                </HelpWrapper>
            </DialoguesWrapper>

            <Analytics />
        </ErrorBoundary>
    </div>
}


export default DesktopLayout;
